// Shared by world.ts and levels.ts
export const K = 'ocean';
